/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class RestoreSecurityGroupsSecurityGroupsInner {
  /**
  * Then name of the security group
  */
  'name': string;
  /**
  * The id of the security group
  */
  'id': string;
  /**
  * The vpc id of the security group
  */
  'vpc': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": ""
    },
    {
      "name": "vpc",
      "baseName": "vpc",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RestoreSecurityGroupsSecurityGroupsInner.attributeTypeMap;
  }

  public constructor() {
  }
}

